import { SearchOutlined } from '@ant-design/icons';
import { Input, Pagination, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../../../context/AuthProvider';
import { updateProps } from '../../../contextRedux/Notification/NotificationModel';
import { RootState } from '../../../store';
import './NotificationTable.css';

const { Search } = Input;

const NotificationTable: React.FC = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state: RootState) => state.store?.notification.data);
  const totalItems = useSelector((state: RootState) => state.models?.notification.props.totalItems);
  const skip = useSelector((state: RootState) => state.models?.notification.props.skip);
  const take = useSelector((state: RootState) => state.models?.notification.props.take);
  const searchTerm = useSelector((state: RootState) => state.models?.notification.props.searchTerm);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const { profile } = useAuth();

  useEffect(() => {
    setCurrentPage(Math.floor(skip / take) + 1);
    setPageSize(take);
  }, [skip, take]);

  const handleSearch = (value: string) => {
    dispatch(updateProps({ field: 'searchTerm', value }));
    dispatch(updateProps({ field: 'skip', value: 0 }));
  };

  const handlePageChange = (page: number, size?: number) => {
    const newSkip = (page - 1) * (size || pageSize);
    dispatch(updateProps({ field: 'skip', value: newSkip }));
    dispatch(updateProps({ field: 'take', value: size || pageSize }));
    setCurrentPage(page);
    if (size) setPageSize(size);
  };

  const columns = [
    {
      title: 'Numar solicitare',
      dataIndex: 'requestFileNumber',
      key: 'requestFileNumber',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Titlu',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
      width: 180,
    },
    {
      title: 'Data',
      dataIndex: 'date',
      key: 'date',
      ellipsis: true,
      width: 120,
    },
    {
      title: 'Client',
      dataIndex: 'client',
      key: 'client',
      ellipsis: true,
    },
    {
      title: 'Punct de lucru',
      dataIndex: 'workPlace',
      key: 'workPlace',
      ellipsis: true,
    },
    {
      title: 'Sisteme',
      dataIndex: 'systems',
      key: 'systems',
      ellipsis: true,
    },
    {
      title: 'Detalii',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
    },
    {
      title: 'Descriere',
      dataIndex: 'describe',
      key: 'describe',
      ellipsis: true,
    },
    {
      title: 'Acțiune',
      key: 'action',
      width: 120,
      fixed: 'right' as const,
      render: (_, record: any) => {
        // Only show "Preiau" button for requestFile type
        if (record.type === 'requestFile' && record.link && !profile.userPermission.rols.includes('pre-sales')) {
          return (
            <button onClick={() => window.open(record.link, '_blank')} className='process-button'>
              Preiau
            </button>
          );
        }
        return null; // Don't show button for other types
      },
    },
  ];

  return (
    <div className='notification-table-container'>
      <div className='notification-table-header'>
        <Search
          placeholder='Caută după titlu sau descriere...'
          allowClear
          enterButton={<SearchOutlined />}
          size='large'
          onSearch={handleSearch}
          defaultValue={searchTerm}
          className='search-input'
        />
      </div>

      <Table
        columns={columns}
        dataSource={notifications || []}
        rowKey='id'
        pagination={false}
        loading={!notifications}
        scroll={{ x: true }}
        className='notification-table'
      />

      <div className='notification-pagination'>
        <Pagination
          current={currentPage}
          total={totalItems || 0}
          pageSize={pageSize}
          showSizeChanger
          showQuickJumper
          showTotal={(total, range) => `${range[0]}-${range[1]} din ${total} notificări`}
          onChange={handlePageChange}
          onShowSizeChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default NotificationTable;
